
<script>

import { defineComponent } from 'vue'

import { useToast } from "vue-toastification";

//data
import { getGalleryOptions } from '@/services/serviceGallery';

export default defineComponent({
	setup() {
		const toast = useToast();
		return { toast }
	},
  name: 'PluginGalleryToArticle',
	data() {
		return {
			preloader:false,
			optionsGalleries: [],
			selectedGallery:''
		}
	},
  props: {
	'auth':Object, 'secData':Object, 'modalObject': Object, 'modalId': String
  },
  emits: ["changeAfterSelect"],
  components: {
    
  }
  ,mounted () {

  },
  
	methods: {
		
		loadGalleries:function(){
				
			this.preloader=true
			
			getGalleryOptions().then(response => {
				if(!response.statusText){
					this.optionsGalleries = response.optionsGalleries;
					this.preloader=false
				}else{
					this.toast.error(`${response.statusText} ${response.status}`);
				}
			});
		
		},

		onSelect:function(e){
			this.$emit('changeAfterSelect', e)
		},

		onCloseModal:function(){
			this.modalObject.hide();
		}

	},
	
	watch: {
		modalId() {
			this.loadGalleries();
		},
	},
	
	created() {

	}
})
</script>

<template>
	<div>

		<div class="modal fade" :id="modalId" tabindex="-1" >
			<div class="modal-dialog modal-fullscreen modal-dialog-scrollable">	
				<div class="modal-content">
					<div class="modal-header">
						<h6 class="modal-title">{{ $t('msgCore.Gallery') }}</h6>
					</div>
					
					<div class="modal-body">
						
						<div class="row">
							<div class="input-group col-md-4 col-12">
								<select v-model='selectedGallery' class="form-control form-control-sm">
									<option  value="">{{ $t('msgCore.selectGallery') }}</option>
									<option v-for="(option) in optionsGalleries" :value="option.value" :key="option">{{ option.title }}</option>
								</select>
								<button type="button" :title="$t('msgCore.btnSend')" class="btn btn-info btn-sm my-btn" v-on:click="onSelect(selectedGallery)">
									Odoslať
								</button>
							</div>
						</div>
										
					</div>
					
					<div class="modal-footer">
						<div class="btn-group">
							<button type="button" v-on:click="onCloseModal()" class="btn btn-default btn-sm">{{ $t('msgCore.btnClose') }}</button>
						</div>	
					</div>
						
				</div>

			</div>
			
		</div>

	</div>
	
</template>